module.exports = __webpack_public_path__ + "img/integral.b704188b.png";